<template>
  <div class="row row-equal">
    <div class="flex xs12 xl8">
      <va-card>
  <template #header>
    {{ $t('dashboard.charts.withdrwasvsdeposits') }}
  </template>

  <template #actions>
    <va-button color="success" class="mr-0" @click="withdrawFunds">
      {{ $t('dashboard.withdraw') }}
    </va-button>
    <va-button color="info" class="mr-0" @click="depositFunds">
      {{ $t('dashboard.deposit') }}
    </va-button>
    <va-button color="danger" class="mr-0" @click="buyAirtime">
      {{ $t('dashboard.buyairtime') }}
    </va-button>
    <va-button color="warning" class="mr-0" @click="calculatorGo">
      {{ $t('dashboard.calculator') }}
    </va-button>
    <va-button icon="fa fa-print" flat class="mr-0" @click="printLineChart" />
  </template>

  <va-chart
    class="chart line--graph"
    ref="lineChart"
    :data="lineChartData"
    type="line"
  />
</va-card>
    </div>

    <div class="flex xs12 md12 xl4">
     <div class="row">
  <div
    class="flex xs6 sm6 lg6 xl6"
    v-on:click="buyVas('KPLC_PREPAID')"
    style="cursor: pointer;"
  >
    <va-card>
      <img :src="getImgUrl('tokenz')" alt="KPLC Prepaid" class="w-full rounded-lg" />
    </va-card>
  </div>

  <div
    class="flex xs6 sm6 lg6 xl6"
    v-on:click="buyVas('KPLC_POSTPAID')"
    style="cursor: pointer;"
  >
    <va-card>
      <img :src="getImgUrl('postk')" alt="KPLC Postpaid" class="w-full rounded-lg" />
    </va-card>
  </div>

  <div class="flex xs6 sm6 lg6 xl6" v-on:click="buyVas('DSTV')" style="cursor: pointer;">
    <va-card>
      <img :src="getImgUrl('dstv')" alt="DSTV" class="w-full rounded-lg" />
    </va-card>
  </div>

  <div class="flex xs6 sm6 lg6 xl6" v-on:click="buyVas('GOTV')" style="cursor: pointer;">
    <va-card>
      <img :src="getImgUrl('gotv')" alt="GOTV" class="w-full rounded-lg" />
    </va-card>
  </div>

  <div class="flex xs6 sm6 lg6 xl6" v-on:click="buyVas('ZUKU')" style="cursor: pointer;">
    <va-card>
      <img :src="getImgUrl('zuku')" alt="Zuku" class="w-full rounded-lg" />
    </va-card>
  </div>

  <div class="flex xs6 sm6 lg6 xl6" v-on:click="buyVas('STARTIMES')" style="cursor: pointer;">
    <va-card>
      <img :src="getImgUrl('start')" alt="Startimes" class="w-full rounded-lg" />
    </va-card>
  </div>

  <div class="flex xs6 sm6 lg6 xl6" v-on:click="buyVas('NAIROBI_WTR')" style="cursor: pointer;">
    <va-card>
      <img :src="getImgUrl('water')" alt="Nairobi Water" class="w-full rounded-lg" />
    </va-card>
  </div>

  <div class="flex xs6 sm6 lg6 xl6" v-on:click="buyVas('AIRTIME')" style="cursor: pointer;">
    <va-card>
      <img :src="getImgUrl('airtime')" alt="Airtime" class="w-full rounded-lg" />
    </va-card>
  </div>
</div>

    </div>


    <va-modal
      v-model="showConfirmModal"
      position="top"
      size = "large"
      :title=" $t('confirm_trans')"
      cancelClass="none"      
      :okText=" $t('modal.submit') "     
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "SubmitForm"
    >
      <div class="flex xs12 md12" v-if="VasForm">
        <p class="flex xs12 md12">Service Payment</p>
        <va-card title="trans">
          <form @submit.prevent="onsubmit">
            <va-input
              :label="$t('amount')"
              type="number"
              v-model="formdata.amount"
              :error="!!amountErrors.length"
              :error-messages="amountErrors"
            />         
            <va-input              
              :label="$t('account_no')"
              v-model="formdata.account_no"           
              :error="!!AccountErrors.length"
              :error-messages="AccountErrors"
            />  
          </form>
        </va-card>
      </div>

      <div class="flex xs12 md12" v-if="AirtimeForm">
        <p class="flex xs12 md12">Buy Airtime</p>
        <va-card title="trans">
          <form @submit.prevent="onsubmit">
            <va-input
              :label="$t('amount')"
              type="number"
              v-model="formdata.amount"
              :error="!!amountErrors.length"
              :error-messages="amountErrors"
            />         
            <va-input              
              :label="$t('recieving_phone_no')"
              v-model="formdata.recieving_phone_no"           
              :error="!!phoneErrors.length"
              :error-messages="phoneErrors"
            />  
          </form>
        </va-card>   
      </div>
    </va-modal>

    <va-modal
      v-model="showConfirmModalfin"
      position="top"
      size = "large"
      :title=" $t('confirm_trans')"
      cancelClass="none"      
      :okText=" $t('modal.confirm') "     
      :cancelText=" $t('modal.cancel')"      
      noOutsideDismiss
      noEscDismiss
      @ok = "FinalPost"
    >
      <table class="va-table va-table--striped va-table--hoverable" width="100%">
        <tbody>
          <tr v-if="AirtimeForm">
            <td>Recieving Phone No.</td>
            <td style="text-align: right;">{{ phone_no }}</td>
          </tr>

          <tr v-if="AirtimeForm">
            <td>Airtime amount</td>
            <td style="text-align: right;">{{ payment_amount | Currency }}</td>
          </tr>         
          <tr v-if="AirtimeForm">
            <td>Transaction Charge</td>
            <td style="text-align: right;">{{ charge | Currency }}</td>
          </tr>      

          <tr v-if="VasForm">
            <td>Service.</td>
            <td style="text-align: right;">{{ trans }}</td>
          </tr>

          <tr v-if="VasForm">
            <td>Account No.</td>
            <td style="text-align: right;">{{ account_no }}</td>
          </tr>

          <tr v-if="VasForm">
            <td>Amount</td>
            <td style="text-align: right;">{{ payment_amount | Currency }}</td>
          </tr>         
          <tr v-if="VasForm">
            <td>Transaction Charge</td>
            <td style="text-align: right;">{{ charge | Currency }}</td>
          </tr>             
        </tbody>
      </table>
    </va-modal>
    <!-- <div class="flex xs12 md12 xl4">
      <va-card :tittle="$t('dashboard.charts.back-office-accs')">
        <va-button
          icon="fa fa-print"
          flat
          slot="actions"
          class="mr-0"
          @click="printChart"
        />
        <va-chart class="chart chart--donut" :data="donutChartData" type="donut"/>
      </va-card>
    </div> -->

    <!-- <div class="flex xs12 md6 xl3">
      <dashboard-contributors-chart/>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
import { getDonutChartData } from '../../data/charts/DonutChartData'
import { getLineChartData } from '../../data/charts/LineChartData'
import DashboardContributorsChart from './DashboardContributorsList'

export default {
  name: 'dashboard-charts',
  components: { DashboardContributorsChart },
  data () {
    return {
      formdata:{        
        recieving_phone_no:'',
        amount:'',
        account_no:'',               
        user: '',
        type: '',
        trans: '',
      },
      amountErrors : [],      
      phoneErrors: [],
      AccountErrors:[],
      lineChartData: {},
      donutChartData: {},
      showConfirmModal:false,
      showConfirmModalfin:false,
      AirtimeForm:false,
      VasForm:true,
      phone_no: '', 
      account_no:'',
      payment_amount : 0,
      charge:0, 
      config:{},
      trans:'',
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      token: JSON.parse(localStorage.getItem('Token')),
      lineChartFirstMonthIndex: 0,
    }
  },
  watch: {
    '$themes.primary' () {
      this.lineChartData = getLineChartData(this.$themes)
      this.donutChartData = getDonutChartData(this.$themes)
    },

    '$themes.info' () {
      this.lineChartData = getLineChartData(this.$themes)
      this.donutChartData = getDonutChartData(this.$themes)
    },

    '$themes.danger' () {
      this.donutChartData = getDonutChartData(this.$themes)
    },
  },
 
  methods: {
    async generateLineChart () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      await axios.post(`${self.$apiUrl}GetIncome`, this.userData.user_id, config)
        .then(function (res) {
          res = res.data
          self.lineChartData = getLineChartData(res, self.$themes)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    async generatedonutchart () {
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      await axios.post(`${self.$apiUrl}getbackofficeaccounts`, this.userData.user_id, config)
        .then(function (res) {
          res = res.data
          localStorage.setItem('UserBosas', JSON.stringify(res))
          console.log(JSON.parse(localStorage.getItem('UserBosas')));
          self.donutChartData = getDonutChartData(res, self.$themes)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    async deleteSection () {
      this.lineChartFirstMonthIndex += 1
      const self = this

      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }

      await axios.post(`${self.$apiUrl}GetIncome`, this.userData.user_id, config)
        .then(function (res) {
          res = res.data
          self.lineChartData = getLineChartData(res, self.$themes, self.lineChartFirstMonthIndex)
        })
        .catch(function (error) {
          console.log(error)
        })
      this.$refs.lineChart.$refs.chart.refresh()
    },
    printChart () {
      const win = window.open('', 'Print', 'height=600,width=800')
      win.document.write(`<br><img src='${this.donutChartDataURL}'/>`)
      // TODO: find better solution how to remove timeout
      setTimeout(() => {
        win.document.close()
        win.focus()
        win.print()
        win.close()
      }, 200)
    },

    printLineChart () {
      const win = window.open('', 'Print', 'height=750,width=1000')
      win.document.write(`<br><img src='${this.lineChartDataURL}'/>`)
      // TODO: find better solution how to remove timeout
      setTimeout(() => {
        win.document.close()
        win.focus()
        win.print()
        win.close()
      }, 200)
    },

    depositFunds(){
      this.$router.push({name: "deposit-funds" });
    },
    withdrawFunds(){
      this.$router.push({name: "cash-withdrawal" });      
    },
    buyAirtime(){
      this.$router.push({name: "buy-airtime" });      
    },
    calculatorGo(){
      this.$router.push({name: "loan-calculator" });      
    },

    getImgUrl(pet) {
      var images = require.context('../../assets/imgs/', false, /\.png$/)
      console.log(images);
      return images('./' + pet + ".png")
    },

    buyVas(id){
      this.showConfirmModal = true;
      this.trans = id;
            
      if(this.trans == 'AIRTIME'){
        this.AirtimeForm =true;
        this.VasForm = false;
      }else{
        this.VasForm = true;
        this.AirtimeForm =false;
      }      
    },



    SubmitForm () {
      this.showConfirmModal=false;
      this.processingError = false;
      
      this.amountErrors = this.formdata.amount ? [] : ['Amount is required'];

      if(this.AirtimeForm){
        this.phoneErrors = this.formdata.recieving_phone_no ? [] : ['Phone No. is required'];
        this.formdata.type = 'Airtime';
      }
      
      if(this.VasForm){
        this.AccountErrors = this.formdata.account_no ? [] : ['Account No.'];
        this.formdata.type = 'Vas';
        this.formdata.trans = this.trans;
      }
      
      
      if (this.formReady) {
        this.loading = true        
        var self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${this.$apiUrl}BuyAirtime`, this.formdata, config)
        .then(function (res) {            
          self.loading = false
          const response = res.data               
          if (response.status == false) {
            self.amountErrors =  response.message_code;
            self.phoneErrors = response.message_code;
            self.showConfirmModal=true;
          }

          if(response.status == true){           
            self.payment_amount = self.formdata.amount
            self.phone_no = self.formdata.recieving_phone_no
            self.account_no = self.formdata.account_no
            self.showConfirmModalfin = true;
          }
          console.log(self.account_no); 
        })
        .catch(function (error) {
            console.log(error)
        })
      }
    },

    FinalPost () {          
        this.loading = true
        var self = this

        let config = {
          headers: {
            Authorization: this.userData.user_id+' '+this.token
          }
        }

        axios.post(`${this.$apiUrl}BuyAirtimefinal`, this.formdata, config)
          .then(function (res) {
            self.loading = false
            const resp = res.data
            if(resp.success == true){              
              self.showToast(`Payment Processed succefully`, {
                position: 'bottom-right',
                icon: "fa-check",
                duration: 2500,
              })
              setTimeout( () => self.$router.go(), 2500);
            } else {
              self.processingError = true
            }
                      
          })
          .catch(function (error) {
              console.log(error)
          })
    },


  },
  computed: {
    donutChartDataURL () {
      return document.querySelector('.chart--donut canvas').toDataURL('image/png')
    },

    lineChartDataURL () {
      return document.querySelector('.line--graph canvas').toDataURL('image/png')
    },

    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

    formReady () {
      return !this.amountErrors.length && !this.AccountErrors.length
    },
  },
  created () {
    this.generateLineChart()
    this.generatedonutchart()
    this.formdata.user  = this.userData.user_id
  },
}
</script>

<style scoped>
  .chart {
    height: 400px;
  }

  .va-card__image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: transparent !important;
    pointer-events: none;
  }
</style>
